<template>
  <collapsible-section
    class="collapse-item"
    :id="`submissionCollapse-form-field-${handler.form.client_id}-${dropdownControlId}`"
    control-name="submissionCollapse"
    :is-open="isOpen(hasFieldDataMatch)"
    :disabled="handler.isSingleOnly && handler.isDisabled(formDataSection.form)"
  >
    <template #section-header>
      <row>
        <prefix>
          <icon :glyph="varIOClass(handler.variable)"/>
        </prefix>
        <column>
          {{ handler.formFieldHeader }}
        </column>
      </row>
    </template>
    <template #section-contents>
      <field-item
        v-if="handler.allowElementContainerSelection"
        :disabled="handler.isDisabled(formDataSection.form)"
        @click="select(formDataSection.select())"
      >
        <row>
          <prefix>
            <icon glyph="form"/>
          </prefix>
          <column>
            {{ formDataSection.form.title }}
          </column>
        </row>
      </field-item>

      <slot name="before-workflow-steps"></slot>

      <div
        v-for="section in formElementSections"
        :key="`${section.workflowStep.client_id}-${dropdownControlId}`"
      >
        <template v-if="modeIs('select')">
          <template>
            <form-element-container-data
              v-if="!handler.usersOnly && section.workflowStep.form_section"
              :handler="handler"
              :element-container="section.workflowStep.form_section"
              recurse
              :parent-tree-context="computedChildTreeContext"
              @select="el => select(section.select(el, section.workflowStep))"
            >
              <template #after-elements>
                <workflow-step-data
                  v-if="section.nonElementFields.length > 0 || !handler.hideWorkflowStepData"
                  :q="q"
                  :handler="handler"
                  :parent-tree-context="parentTreeContext"
                  :section="section"
                  @select="select"
                 />
              </template>
            </form-element-container-data>

            <non-form-section-workflow-step-data
              v-else-if="section.nonElementFields.length > 0 || !handler.hideWorkflowStepData || handler.usersOnly"
              :q="q"
              :handler="handler"
              :parent-tree-context="parentTreeContext"
              :section="section"
              @select="select"
            />
          </template>
        </template>
      </div>

      <slot name="after-workflow-steps"></slot>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
  import Vue from 'vue';
  import FormElementDynamicFieldsHandler from "~/models/dynamicFields/handlers/formElementDynamicFieldsHandler";
  import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
  import CollapsibleSection from './common/collapsible-section.vue';
  import FieldItem from './common/field-item.vue';
  import FormElementsSectionWrapper from './form-elements-section-wrapper.vue';
  import FormElementContainerData from './form-element-container-data.vue';
  import {IDynamicTreeContext, IFormDataSection, IFormDynamicFieldSection} from "~/interfaces/dynamicFieldsInterfaces"
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
  import DynamicElementMixin from './common/dynamic-element-mixin.vue';
  import SectionFields from '~/components/dynamicFieldsTrees/handlerComponents/common/section-fields.vue'
  import WorkflowStepData from '~/components/dynamicFieldsTrees/handlerComponents/workflow-step-data.vue';
  import NonFormSectionWorkflowStepData from '~/components/dynamicFieldsTrees/handlerComponents/non-form-section-workflow-step-data.vue';

  export default Vue.extend({
    mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
    components: {
      NonFormSectionWorkflowStepData,
      CollapsibleSection,
      FieldItem,
      FormElementsSectionWrapper,
      FormElementContainerData,
      SectionFields,
      WorkflowStepData,
    },
    props: {
      handler: {
        type: Object as () => FormElementDynamicFieldsHandler,
        required: true,
      },
      parent: {
        type: Object,
        default: null
      },
      restrictResultsToParentContext: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      hasFieldDataMatch(): boolean {
        return this.handler.hasFieldDataMatch(this.lowerQ, this.parent, this.restrictResultsToParentContext);
      },
      formDataSection(): IFormDataSection {
        return this.handler.formDataSection(this.lowerQ);
      },
      formElementSections(): IFormDynamicFieldSection[] {
        return this.handler.formElementSections(this.lowerQ, this.handler.form, this.restrictResultsToParentContext);
      },
      treeContext(): Partial<IDynamicTreeContext> {
        return {}
      },
    },
  });
</script>